import { SET_SUBMENU_TIMEOUT, RANDOM_NUMBER_MULTIPLIER, LAST_LEVEL, ADD_ONE_LEVEL } from "./constants";

export const handleDeleteClick = ({
  setCurrentType,
  setOpenConfirmationPopup,
  type,
}) => {
  setCurrentType(type);
  setOpenConfirmationPopup(true);
};

export const handleDeleteAction = ({
  id,
  isTerminal,
  currentData,
  handleApiCall,
}) => {
  const updatedData = currentData
    .map((item) => {
      if (isTerminal) {
        return {
          ...item,
          OrgDevices: item.OrgDevices?.filter(
            (device) => device.DeviceId !== id
          ),
        };
      } else {
        return item.OrgId !== id && item.ParentOrgId !== id ? item : null;
      }
    })
    .filter((item) => item !== null);

  handleApiCall(updatedData);
};

export const handleAddClick = ({
  sentData,
  type,
  parent,
  isTerminal,
  currentData,
  setSubMenuID,
  setSelectedData,
  setIsPopupOpen,
  originalData,
}) => {
  const dataSelected =
    isTerminal || type === "terminal"
      ? currentData.find((item) => item.OrgId === (sentData.id || sentData))
      : currentData.find((item) => item.OrgId === sentData);
  const originalParent = currentData.find((item) => item.OrgId === parent?.id);

  if (dataSelected && originalParent) {
    setTimeout(() => {
      setSubMenuID(null);
    }, SET_SUBMENU_TIMEOUT);
    setSelectedData({
      data:
        type === "terminal"
          ? dataSelected
          : {
              LastUpdateDate: new Date().toISOString(),
              ParentOrgExternalReference: originalParent?.OrgExternalReference,
              ParentOrgId: originalParent?.ParentOrgId,
              Level: dataSelected.Level === LAST_LEVEL ? LAST_LEVEL : dataSelected.Level + ADD_ONE_LEVEL,
              OrgDetails: [
                {
                  LanguageCode: "en",
                  Abbreviation: null,
                  ShortName: "",
                  LongName: "",
                  StatusName: "Active",
                },
                {
                  LanguageCode: "ar",
                  Abbreviation: null,
                  ShortName: "",
                  LongName: "",
                  StatusName: null,
                },
              ],
              OrgAttributes: [],
              OrgDevices: [],
              OrgAddresses: [],
              OrgContacts: [],
              OrgId: Math.floor(Math.random() * RANDOM_NUMBER_MULTIPLIER),
              StatusTag: "ACTIVE",
            },
      type: type,
      action: "add",
      parent: originalParent,
      orginalData: originalData,
      transformedData: sentData,
    });
    setIsPopupOpen(true);
  }
};

export const handleEditClick = ({
  sentData,
  type,
  parent,
  isTerminal,
  sentTerminalId,
  addType,
  currentData,
  setSubMenuID,
  setSelectedData,
  setIsPopupOpen,
}) => {
  const dataSelected =
    isTerminal || addType === "terminal"
    ? currentData.find((item) => item.OrgId === sentData.id)
    : currentData.find((item) => item.OrgId === sentData);
  const originalParent = currentData.find((item) => item.OrgId === parent?.id);

  if (dataSelected && originalParent) {
    setTimeout(() => {
      setSubMenuID(null);
    }, SET_SUBMENU_TIMEOUT);
    setSelectedData({
      data: dataSelected,
      type: type,
      action: "edit",
      parent: originalParent,
      dataId: isTerminal ? sentTerminalId : sentData,
      transformedData: sentData,
    });
    setIsPopupOpen(true);
  }
};

export const handleSaveChanges = ({
  updatedChanges,
  isNew,
  currentData,
  handleApiCall,
}) => {
  const updatedData = isNew
    ? [...currentData, updatedChanges]
    : currentData.map((item) =>
        item.OrgId === updatedChanges.OrgId ? updatedChanges : item
      );
  handleApiCall(updatedData);
};

export const toggleRegion = ({
  regionId,
  setSubMenuID,
  setExpandedRegions,
}) => {
  setSubMenuID(null);
  setExpandedRegions((prev) => ({
    ...prev,
    [regionId]: !prev[regionId],
  }));
};

export const toggleOutlet = ({
  outletId,
  setSubMenuID,
  setExpandedOutlets,
}) => {
  setSubMenuID(null);
  setExpandedOutlets((prev) => ({
    ...prev,
    [outletId]: !prev[outletId],
  }));
};

export const toggleBranch = ({
  branchId,
  setSubMenuID,
  setExpandedBranches,
}) => {
  setSubMenuID(null);
  setExpandedBranches((prev) => ({
    ...prev,
    [branchId]: !prev[branchId],
  }));
};

export const filterHierarchy = ({
  hierarchy,
  searchTerm,
  setExpandedRegions,
  setExpandedOutlets,
  setExpandedBranches,
}) => {
  const expandedRegions = {};
  const expandedOutlets = {};
  const expandedBranches = {};
  const filteredHierarchy = hierarchy
    .map((region) => {
      const filteredOutlets = region.outlets
        .map((outlet) => {
          const filteredBranches = outlet.branches
            .map((branch) => {
              const filteredAddresses = branch.addresses.filter((address) =>
                address.toLowerCase().includes(searchTerm.toLowerCase())
              );
              const filteredContacts = branch.contacts.filter((contact) =>
                contact.ContactValue.toLowerCase().includes(
                  searchTerm.toLowerCase()
                )
              );
              const filteredTerminals = branch.terminals.filter((terminal) =>
                terminal.name.toLowerCase().includes(searchTerm.toLowerCase())
              );

              if (
                branch.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                !!filteredAddresses.length ||
                !!filteredContacts.length ||
                !!filteredTerminals.length
              ) {
                expandedBranches[branch.id] = true;
                return {
                  ...branch,
                };
              }
              return null;
            })
            .filter((branch) => branch !== null);

          if (
            outlet.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            !!filteredBranches.length
          ) {
            expandedOutlets[outlet.id] = true;
            return {
              ...outlet,
            };
          }
          return null;
        })
        .filter((outlet) => outlet !== null);

      if (
        region.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        !!filteredOutlets.length
      ) {
        expandedRegions[region.id] = true;
        return {
          ...region,
          outlets: filteredOutlets,
        };
      }
      return null;
    })
    .filter((region) => region !== null);

  setExpandedRegions(expandedRegions);
  setExpandedOutlets(expandedOutlets);
  setExpandedBranches(expandedBranches);

  return filteredHierarchy;
};
